import React, { useEffect, useState } from 'react'
import axios from '../../API/axios';
import { Link } from 'react-router-dom';
import Button from '../../components/button';


const TopCandidates = (props) => {
    const token = localStorage.getItem('token')
    const { className } = props;
    const [candidates, setCandidate] = useState([]);
    const CandidateList = (page) => {
        const data = {
            pageNumber: page,
            pageSize: 20
        }
        axios.post(`/Candidate/GetAll `, data)
            .then((response) => {
                const res = response.data.responseData.candidateProfiles;
                console.log("getAllUserList", response.data.responseData.candidateProfiles);
                setCandidate(res);

            })
            .catch((error) => {

                console.log(error);
            });
    };

    useEffect(() => {
        CandidateList();
    }, []);


    return (
        <>
            <section className={className}>
                <div className="container">
                    <div className="wd-employer">
                        <div className="tf-title">
                            <div className="group-title">
                                <h1>Top Candidates</h1>
                            </div>
                            <Button title="All Candidate" link="/Candidates" />
                        </div>
                        <div className="row wow fadeInUp">
                            {candidates.slice(0, 4).map((candidate, idx) => (
                                <div key={idx.id} className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                                    <div className="employer-block">
                                        <div className="inner-box">
                                            <div className="logo-company">
                                                <img src={candidate.profileImage} alt='' />
                                            </div>
                                            <div className="box-content">

                                                <h3>
                                                    {token === null ? candidate.firstName : <Link to="/employers_v1">{candidate.firstName} {candidate.lastName}</Link>}
                                                    &nbsp;
                                                </h3>
                                                <p className="info">
                                                    {candidate.cityName === null ? '' : <>
                                                        <span className="icon-map-pin"></span>{candidate.cityName}</>}

                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default TopCandidates